<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-scrollbar>
        <div class="setAddressList" v-if="list!=null">
          <ul>
            <li v-for="(item,index) in list" :key='index' :class="newadd==index?'on':''" @click="setOnlyAddress(index,item)">
              <div>
                <div class="addressName">{{item.City}} ({{item.UserName}}{{$i18n.locale==='zh'?"收":""}})</div>
                <div class="addressText line_txt2">{{item.Provice|setProvice}} {{item.AddressDetail}} {{item.ZipCode}}</div>
                <div class="addressPhone">{{item.Email}}</div>
                <div class="addressPhone">{{item.Mobile}}</div>
              </div>
              <span class="default" v-if="item.IsDefault">{{$t('MakePrimary')}}</span>
              <span class="setAddress" @click="setAddress('address',1,item)">{{$t('Edit')}}</span>
            </li>
          </ul>
        </div>
      </el-scrollbar>
      <div class="setaddressnew">
        <div class="setinfo" @click="setAddress('address',0)">{{$t('AddNewAddress')}}</div>
      </div>
      <div class="setaddressbtn">
        <el-button :disabled='disabled' type="primary" @click="submitForm()">{{$t('Save')}}</el-button>
        <el-button @click="closeDialog">{{$t('Cancel')}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getInfo,Tip } from "@/api/public";
export default {
  name: 'setaddress',
  components: {},
  data() {
    return {
      userInfo: getInfo(),
      pi: this.$enumInfo.addressPage.pageindex,
      ps: this.$enumInfo.addressPage.pagesize,
      list: null,
      isNull: null,
      loading: false,
      disabled: true,
      isAdd: 0,
      newadd: 0,
      newaddInfo: null,
      dialogClass: 'setaddress',
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
    infoList: {}
  },
  filters: {
    setProvice(val){
      // var regex = /(<([^>]+)>)/ig;
      if(val!=null){
        // val=val.replace(regex,'');
        val=val.replace(/\-/g,' ');
        //val=val.replace('&nbsp;','');
      }
      return val
    }
  },
  created() {
    this.getAddress();
  },
  mounted() {
    //console.log(this.$interface.SignIn)
  },
  methods: {
    //获取地址列表
    getAddress() {
      let that = this;
      that.loading = true;
      let data = { MemberId: that.userInfo._id, PageIndex: that.pi, PageSize: that.ps }
      that.$get(that.$interface.SearchShippingAddresses, data).then(res => {
        if (res.Result != 0) {
          that.setDefaultAddress(res);
        } else {
          that.isNull = true;
        }
        that.loading = false;
      })
    },
    // 设置当前订单默认地址
    setDefaultAddress(res) {
      let that = this;
      that.list = res.Data;
      that.isNull = res.Count > 0 ? false : true;
      if (res.Count > 0) {
        let num = 0;
        let isDefault = null;
        res.Data.map((item, index) => {
          if (that.infoList.AddressId == item._id) {
            this.newadd = index;
            this.isAdd = index;
            this.newaddInfo = item;
            num++;
          }
        })
        if (num == 0) {
          res.Data.map((item, index) => {
            if (item.isDefault) {
              this.newaddInfo = item;
            }
          })

        }
      }
    },
    // 跳转修改地址弹框
    setAddress(val, type, obj) {
      this.closeDialog();
      this.$emit('setAddress', val, type, obj)
    },
    // 判断是否是最开始的地址
    setOnlyAddress(val, obj) {
      this.newadd = val;
      if (this.newadd != this.isAdd) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      this.newaddInfo = obj;
    },
    // 提交表单
    submitForm() {
      let that = this;
      if(that.newaddInfo.Email){
        that.loading = true;
        that.disabled = true;
        let data = {
          id: that.infoList._id,
          addressId: that.newaddInfo._id,
          userName: that.newaddInfo.UserName,
          mobile: that.newaddInfo.Mobile,
          email:that.newaddInfo.email,
          provice: that.newaddInfo.Provice,
          city: that.newaddInfo.City,
          addressDetail: that.newaddInfo.AddressDetail,
          zipCode: that.newaddInfo.ZipCode,
          country: that.newaddInfo.Country,
        }
        that.$post(that.$interface.ModifyOrderAdress, data).then(res => {
          if (res.Result != 0) {
            that.$emit('closeDialog', 'setOrderAddress', false, 1)
          }else{
            that.$message.error(res.Msg);
          }
          that.loading = true;
        })
      }else{
        Tip('warning',that.$t('alertEmail'))
      }
    },
    // 关闭弹框
    closeDialog(val) {
      this.$emit('closeDialog', 'setOrderAddress', false)
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/address.css";

</style>



// WEBPACK FOOTER //
// src/components/dialog/setaddress.vue